























import { Component, Vue } from 'vue-property-decorator'
import CardPanel from '@/components/common/CardPanel.vue'
import TaskManagementList from '@/components/common/TaskManagementList.vue'
import RecentTasks from '@/components/common/RecentTasks.vue'

@Component({
  components: {
    CardPanel,
    RecentTasks,
    TaskManagementList
  }
})
export default class TaskManagement extends Vue {
  private activeName: string = 'center' // center-任务管理中心 recent-最近任务
  private handleClick () {

  }
}
